import { usePrompt } from '@common/hooks/usePrompt';
import React, { useCallback, useEffect } from 'react';
// import { usePrompt } from "./usePrompt";

const defaultMessage = 'Leave the page? Changes you made may not be saved.';

// courtesy: https://github.com/codegeous/react-component-depot/blob/master/src/hooks/useUnsavedChangesWarning.js
export const useUnsavedChangesWarning = (
  isDirty: boolean,
  message = defaultMessage,
) => {
  const beforeUnload = useCallback(
    (event: any) => {
      event.preventDefault();
      return (event.returnValue = message);
    },
    [message],
  );

  useEffect(() => {
    //Detecting browser closing
    if (isDirty) {
      window.removeEventListener('beforeunload', beforeUnload);
      window.addEventListener('beforeunload', beforeUnload);
    } else {
      window.removeEventListener('beforeunload', beforeUnload);
    }

    return () => {
      window.removeEventListener('beforeunload', beforeUnload);
    };
  }, [isDirty, message, beforeUnload]);

  usePrompt(message, isDirty);

  return <></>;
};
